import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import { Params } from "@/types";
import { handleThunkError } from "@/utils/thunkErrorHandler";

const endpoint = {
  purchases: "/purchases",
  expenses: "/expenses",
};

export const fetchPurchases = createAsyncThunk(
  "purchases/fetchPurchases",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.purchases, {
        params,
      });
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao carregar compras");
    }
  },
);

export const createPurchase = createAsyncThunk(
  "purchases/createPurchase",
  async (purchaseData: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoint.purchases,
        purchaseData,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao criar compra");
    }
  },
);

export const updatePurchase = createAsyncThunk(
  "purchases/updatePurchase",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.purchases}/${data.id}`,
        data,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao atualizar compra");
    }
  },
);

export const deletePurchase = createAsyncThunk(
  "purchases/deletePurchase",
  async (id: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.purchases}/${id}`,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao excluir compra");
    }
  },
);

export const patchPurchase = createAsyncThunk(
  "purchases/patchPurchase",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.patch(
        `${endpoint.expenses}/${data.id}/settlement`,
        data,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao liquidar compra");
    }
  },
);
